import { useState, useEffect } from 'react';

/**
 * Změří prvek přes ResizeObserver a vrátí `[ref, { w, h }]`.
 *
 * Dlaždice cockpitu se řídí reálnou velikostí, ne breakpointem okna — stejná
 * dlaždice má jinou výšku na notebooku a na 4K monitoru a obsah se tomu musí
 * přizpůsobit. `ref` je callback ref, takže měření chytí i prvek, který se
 * vykreslí až později (např. po načtení dat).
 *
 * Měří se vnější rozměr (border-box), ne obsah. Dlaždice podle naměřené
 * velikosti mění vlastní odsazení — kdyby se měřil obsah, změna odsazení by
 * změnila měření a layout by mezi dvěma stavy oscilloval.
 */
export default function useRozmer() {
    const [el, setEl] = useState(null);
    const [rozmer, setRozmer] = useState({ w: 0, h: 0 });

    useEffect(() => {
        if (!el) return;
        if (typeof ResizeObserver === 'undefined') {
            setRozmer({ w: el.offsetWidth, h: el.offsetHeight });
            return;
        }
        const ro = new ResizeObserver(([zaznam]) => {
            const box = zaznam.borderBoxSize?.[0];
            const width = box ? box.inlineSize : zaznam.target.offsetWidth;
            const height = box ? box.blockSize : zaznam.target.offsetHeight;
            // Sub-pixelové změny ignorujeme — jinak by ResizeObserver točil
            // render smyčku při každém přepočtu layoutu.
            setRozmer(p => (Math.abs(p.w - width) < 0.5 && Math.abs(p.h - height) < 0.5
                ? p : { w: width, h: height }));
        });
        ro.observe(el);
        return () => ro.disconnect();
    }, [el]);

    return [setEl, rozmer];
}
